import { createSelector, createSlice } from "@reduxjs/toolkit";
import K from "utilities/constants";

const { Redux } = K;

const initialState = {
  [Redux.SelectedClients]: [],
  [Redux.SelectedRecruiters]: [],
  [Redux.ClientSelection]: "all",
};

export const globalSelectorSlice = createSlice({
  name: "globalSelector",
  initialState,
  reducers: {
    setGlobalClients: (state, action) => {
      state[Redux.SelectedClients] = action.payload;
    },
    setClientSelectionType: (state, action) => {
      state[Redux.ClientSelection] = action.payload;
    },
    setGlobalRecruiters: (state, action) => {
      state[Redux.SelectedRecruiters] = action.payload;
    },
    setInitialSelector: (state, action) => {
      const { data, isSuperAdmin } = action.payload;
      const clientsList = data.basicDetail.clients.map(({ id }) => id);
      state[Redux.SelectedClients] = isSuperAdmin ? [] : clientsList;
      state[Redux.SelectedRecruiters] = [];

      if (!isSuperAdmin) {
        state[Redux.SelectedRecruiters] = data.recruiters.map((r) => r.id);
        state[Redux.ClientSelection] = K.Clients.SelectionType.None;
      }
    },
  },
});

export const selectGlobalSelector = (state) => state.globalSelector;

export const selectClientSelection = createSelector(
  selectGlobalSelector,
  (globalSelector) => globalSelector.clientSelection,
);

export const selectSelectedClientIds = createSelector(
  selectGlobalSelector,
  (globalSelector) => globalSelector.selectedClients,
);

export const {
  setGlobalClients,
  setInitialSelector,
  setGlobalRecruiters,
  setClientSelectionType,
} = globalSelectorSlice.actions;
export default globalSelectorSlice.reducer;
